import Alpine from 'alpinejs'

export const initPictureViewer = (): void => {
    Alpine.data('pictureViewer', (licensePlate: string | null, vin: string) => ({
        theme: 'wealer2024',
        VivitionInitialized: false,
        licensePlate,
        init() {
            this.checkVivition(this.theme, vin).then(this.mount(this.$refs))
        },
        checkVivition(theme: string, vin: string): Promise<void> {
            // Helper function to check a given URL using fetch
            const checkURL = async (url: string): Promise<void> => {
                try {
                    const response = await fetch(url)

                    if (!response.ok) {
                        throw new Error(`Fetch failed with status ${response.status}`)
                    }

                    const json = await response.json()

                    if (json && json.existing) {
                        this.VivitionInitialized = true
                    } else {
                        throw new Error('Response exists but is not valid')
                    }
                } catch (error) {
                    throw new Error(`Error during fetch: ${(error as Error).message}`)
                }
            }

            return (async () => {
                if (!this.licensePlate && !vin) {
                    throw new Error('Either licence plate or VIN must be provided.')
                }
                if (this.licensePlate) {
                    const hasAlpha = /[a-zA-Z]/.test(this.licensePlate)
                    const hasNumeric = /[0-9]/.test(this.licensePlate)
                    if (!hasAlpha || !hasNumeric) {
                        console.log('Licence plate must contain both alpha and numeric characters, setting to null')
                        this.licensePlate = null
                    }
                }

                console.log('Licence plate:', this.licensePlate)

                if (this.licensePlate) {
                    try {
                        await checkURL(`https://static-api.vivition.com/${theme}/licenceplate_vin/${this.licensePlate}_/existing.json`)
                        return
                    } catch (_) {
                        // Fall through to try with VIN
                        console.log('Error checking VIN:', _)
                    }
                }

                // Try base fallback with VIN
                await checkURL(`https://static-api.vivition.com/${theme}/licenceplate_vin/_${vin}/existing.json`)
            })()
        },
        mount(refs) {
            refs.pictureRoot.innerHTML =
                `<div ${vin !== '' ? `data-vin="${vin}" ` : ''}${this.licensePlate == null ? '' : `data-licenceplate="${this.licensePlate}" `}data-theme="${
                    this.theme
                }" class="vivition-player"></div>` +
                `<div class="vivition-thumbbar"></div>` +
                `<style>.vivition-player { height:0;padding-bottom: 66.66% } .vivition-thumbbar { height: 100px;margin-top:4px; } ` +
                `body.vivition-mobile .vivition-thumbbar { height: 65px; } @media(max-width:768px) { .vivition-thumbbar { height: 65px; } }.thumbcontainer { display: block !important }` +
                `.thumbnr {display: none !important;} .vivition-player {background: url(https://static-api.vivition.com/${
                    this.theme
                }/licenceplate_vin/_${vin}/initialphoto.jpg) no-repeat center / cover;}` +
                `@media screen and (min-width: 768px) {.vivition-player {background: url(https://static-api.vivition.com/${
                    this.theme
                }/licenceplate_vin/_${vin}/initialphoto_desktop.jpg) no-repeat center / cover; }}` +
                `</style>`

            // Insert the VIVITION Script at the bottom of the body
            const script = document.createElement('script')
            script.setAttribute('type', 'text/javascript')
            script.setAttribute('src', 'https://static-api.vivition.com/scripts/vivition.virtualvehicletour.js')
            script.appendChild(document.createTextNode(''))
            document.body.appendChild(script)
        },
    }))
}
